import { render, staticRenderFns } from "./subject-table.vue?vue&type=template&id=b1169ace&scoped=true&"
import script from "./subject-table.vue?vue&type=script&lang=js&"
export * from "./subject-table.vue?vue&type=script&lang=js&"
import style0 from "./subject-table.vue?vue&type=style&index=0&id=b1169ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1169ace",
  null
  
)

export default component.exports